import {ADICIONAR_FILTRO_PRESTADOR} from '../types'

export default function adicionarFiltroPrestador (filtro) {
  return {
    type: ADICIONAR_FILTRO_PRESTADOR,
    payload: filtro
  }
}
